// extracted by mini-css-extract-plugin
export default {"card":"DeleteInvoiceCard_card__IGyzR","color":"DeleteInvoiceCard_color__819tu","date":"DeleteInvoiceCard_date__Al01g"};